import Vue from 'vue'
import Vuex from 'vuex'
import accounts from './modules/accounts.js'
import configs from './modules/configs.js'
import bonds from './modules/bonds.js'
import statements from './modules/statements.js'
import currencies from './modules/currencies.js'
import customStatements from './modules/custom-statements.js'
import entries from './modules/entries.js'
import auth from './modules/auth.js'
import financialFiles from './modules/financial-files.js'
import weather from './modules/weather.js'
import permissions from '../permissions/store/permissions.js'
import users from './modules/users.js'
import hashes from '../syncing/store/hashes.js'
import warehouses from './modules/warehouses.js'
import materials from './modules/materials.js'
import unitSizes from './modules/unit-sizes.js'
import invoices from './modules/invoices.js'
import materialsJournals from './modules/materials-journals.js'
import manufacturing from './modules/manufacturing'
import reports from './modules/reports'
import transactionBonds from './modules/transactionBonds.js'
import transactions from './modules/transactions.js'
import roles from './modules/roles.js'
import statistics from './modules/statistics.js'
import auditLogs from './modules/audit-logs.js'
import invoiceCategories from './modules/invoice-categories.js'
import deliveryStatus from './modules/delivery-status.js'
import settings from './modules/settings.js'
import orders from './modules/orders.js'
import offers from './modules/offers.js'
import backups from './modules/backups.js'
Vue.use(Vuex)

export default new Vuex.Store({
    namespaced: false,
    modules :{
        accounts ,
        configs,
        bonds,
        statements,
        currencies,
        customStatements,
        entries,
        auth,
        financialFiles,
        weather,
        permissions,
        users,
        hashes,
        warehouses,
        materials,
        unitSizes,
        invoices,
        materialsJournals,
        manufacturing,
        reports,
        transactionBonds,
        transactions,
        roles,
        statistics,
        auditLogs,
        invoiceCategories,
        deliveryStatus,
        settings,
        orders,
        offers,
        backups
    },
})